import React from 'react';
import { ProfilePictureName } from '../../../_lib/components/ProfilePictureName';
import ILink from '../../../types/ILink';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import IUrl from '../../../types/IUrl';
import { Form, SonForm, StatusMessages, useForm } from '../../../_lib/Form2';
import { BtnModifier } from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Button } from '../../../components/molecules/Btn/Button';
import { AnyParameter } from '../../../_lib/Form2/types/SonForm';
import { Heading } from '../../../_lib/components/Heading/Heading';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

export type TeamRoomMemberRequestsListItem = {
  profileLink: ILink;
  profileImageUrl: ProfileImageSmall;
  personInfoCardUrl: IUrl;
  actions: { approveRequest: SonForm<AnyParameter>; rejectRequest: SonForm<AnyParameter> };
};

export function TeamRoomMemberRequestsListItem({
  profileLink,
  profileImageUrl,
  personInfoCardUrl,
  actions,
}: TeamRoomMemberRequestsListItem) {
  const { t } = useSonTranslation('TeamRoomMemberRequests');
  const { delayedRefresh } = useRefreshBlock();

  const { formProps, fetchState } = useForm({ form: actions.approveRequest, onSuccess: delayedRefresh });

  return (
    <>
      <ProfilePictureName
        profileLink={profileLink}
        profileImageUrl={profileImageUrl}
        profileName={profileLink.name}
        personInfoCardUrl={personInfoCardUrl}
      />
      <Form {...formProps} modifier="no-padding">
        <div className="accept-decline-form">
          <Heading hierarchy={3} className="accept-decline-form__headline font-regular-15-23">
            {t('instantinteraction.question')}
          </Heading>
          <div className="accept-decline-form__buttons">
            <Button
              type="submit"
              modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES]}
              aria-disabled={fetchState.type === 'success' || fetchState.type === 'loading'}
            >
              <Button.Icon svgSpriteId={Icons.ACCEPT_CHECK} text={t('glossary:yes')} />
            </Button>
            <Button
              formAction={actions.rejectRequest.url}
              type="submit"
              modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_NO]}
              aria-disabled={fetchState.type === 'success' || fetchState.type === 'loading'}
            >
              <Button.Icon svgSpriteId={Icons.DECLINE_CROSS} text={t('glossary:no')} />
            </Button>
          </div>
        </div>
        <StatusMessages
          messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
          messageSuccess={fetchState.currentAction?.endsWith(actions.approveRequest.url)
            ? t('instantinteraction.approve.success')
            : t('instantinteraction.reject.success')}
          messageFail={fetchState.currentAction?.endsWith(actions.approveRequest.url)
            ? t('instantinteraction.approve.fail')
            : t('instantinteraction.reject.fail')}
          fetchState={fetchState}
        />
      </Form>
    </>
  );
}
